import type { ComponentStyleConfig } from '@chakra-ui/theme';

const EmptyStateTheme: ComponentStyleConfig = {
  baseStyle: ({ maxContentWidth }) => ({
    box: {
      alignItems: 'center',
      backgroundColor: 'neutral.95',
      borderRadius: '4',
      color: 'text.secondary',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingX: '16',
      paddingY: {
        base: '32',
        desktop: '48',
      },
      textAlign: 'center',
    },
    description: {
      '+ *': {
        marginTop: '16',
      },
      marginTop: '4',
      maxWidth: maxContentWidth || '35rem',
    },
    title: {
      fontWeight: 'bold',
      marginTop: '8',
      maxWidth: maxContentWidth || '35rem',
    },
  }),
  parts: ['box', 'title', 'description'],
};

export default EmptyStateTheme;
